export enum Permissions {
    canViewLogs = "canViewLogs",
    userManagement = "userManagement",
    releaseManagement = "releaseManagement",
    releaseEditing = "releaseEditing",
    importData = "importData",
    fileManagement = "fileManagement",
    sendNewsletters = "sendNewsletters",
    convertSubmissions = "convertSubmissions",
    recheckTikTok = "recheckTikTok",
}